define(["jquery", "underscore", "marionette"], function ($, _, Marionette) {
    return Marionette.View.extend({
        el: "#vn_promotion_modal",
    
        ui: {
            closeTodayBtn: ".close-today",
        },
    
        events: {
            "click @ui.closeTodayBtn": "onClickCloseTodayButton",
        },

        initialize: function() {
            const expireTime = localStorage.getItem('vnPromotionModalExpire');
            const now = new Date().getTime();

            if (expireTime && now < parseInt(expireTime)) {
                this.$el.css('display', 'none'); 
            } else {
                this.$el.css('display', 'block');
            }
        },

        onClickCloseTodayButton: function (e) {
            const expirationDate = new Date();
            expirationDate.setHours(expirationDate.getHours() + 24);
            
            localStorage.setItem('vnPromotionModalExpire', expirationDate.getTime());
            
            this.$el.css('display', 'none');
        }
    });
});
